var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eudr-map-wrap",on:{"mouseleave":_vm.onPolygonHoverEnd}},[_c('div',{style:({ width: '100%', height: _vm.height }),attrs:{"id":_vm.mapId,"data-testid":"eudr-map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }